import React from "react";
import { AllocationMatrixGuest } from "services/BookingManagerApi/types/AllocationsResponse";
import { UserComponent } from 'ui/Icons';

export const BreakdownAllocationTooltipContent: React.FC<{ guests: AllocationMatrixGuest[] }> = ({ guests = [] }) => (
  <div className='max-h-[195px] rounded-1px font-pt-sans'>
    <div className='text-brown-prime text-13px mb-10px font-bold'>
      Guests Allocation Info
      <div className="font-light">Assigned To:</div>
    </div>
    <div className='overflow-auto max-h-[158px] flex flex-col gap-10px'>
      {guests.length > 0 ?
        guests.map(guest => {
          return (
            <div key={guest.uuid} className="flex items-center gap-5px">
              <UserComponent icon="gray-40" className="h-18px w-18px" />
              <div className="text-black text-13px leading-snug mr-2px">{guest.name} {guest.isLeadGuest && <span className="text-status-enquiry text-[13px] italic">Lead</span>}</div>
            </div>
          );
        }) :
        'None'
      }
    </div>
  </div>
)
